import classNames from "classnames";
import { FC } from "react";
import InfiniteScroll from "react-infinite-scroller";
import AdsIds from "../../../../data/ads";
import { API } from "../../../../services/api/types";
import { randomNumber } from "../../../../utils/number";
import Advertisement from "../../../Advertisement";
import ArticleItem from "../../../ArticleItem";
import OnScreen from "../../../OnScreen";
import SectionHeader from "../../../SectionHeader";

type NativeFeedDesktopProps = {
  news: API.Article[];
  onReachEnd: () => void;
  onArticleAppear: (article: API.Article, position: "above" | "below") => void;
  onArticleDisappear: (
    article: API.Article,
    position: "above" | "below"
  ) => void;
};

const NativeFeedNewsDesktop: FC<NativeFeedDesktopProps> = (props) => {
  return (
    <InfiniteScroll hasMore={true} pageStart={0} loadMore={props.onReachEnd}>
      <SectionHeader labelTag="h1" label="Native - sponsrade artiklar" />
      {props.news.map((article, index) => {
        const isShowingNativeAd = index === 3;
        const isShowingAd = index % 6 === 0 && index !== 0;
        const type = index % 3 === 0 ? "large" : "medium";

        return (
          <div key={article.id}>
            {isShowingAd && (
              <div className={classNames(["py-5", "border-b"])}>
                <Advertisement
                  id={AdsIds.dynamic_desktop}
                  codeReplaceAll={() => ({
                    tagId: `fotbolltransfers_mpu_${randomNumber(
                      1,
                      Math.pow(10, 6)
                    )}`,
                  })}
                />
              </div>
            )}
            {isShowingNativeAd && (
              <div className={classNames(["py-5", "border-b"])}>
                <Advertisement id={AdsIds.desktop_native} />
              </div>
            )}
            <div className={classNames(["py-5", "border-b"])}>
              <OnScreen
                onAppear={(position) =>
                  props.onArticleAppear(article, position)
                }
                onDisappear={(position) =>
                  props.onArticleDisappear(article, position)
                }
              >
                <ArticleItem article={article} type={type} />
              </OnScreen>
            </div>
          </div>
        );
      })}
    </InfiniteScroll>
  );
};

export default NativeFeedNewsDesktop;
